import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { deleteenquiry, listenquiry } from "../../../services/common";
import Select from "react-select";
import { academylist } from "../../../services/admin";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

export default function Allenquiry() {
  const navigate = useNavigate();
  const [filterProduct, setFilterProduct] = useState([]);
  const [fdate, setFDate] = useState("");
  const [tdate, setTDate] = useState("");

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const columnDefs = [
    {
      headerName: "Actions",
      width: 100,
      field: "id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => navigate(`/enquiry/enquirydetail/${params.value}`)}
              className="btn-sm btn-info me-2"
            >
              <i className="fa fa-edit"></i>
            </a>
            <a
              onClick={() => deleteenq(params.value)}
              className="btn-sm btn-danger"
            >
              <i className="fa fa-trash"></i>
            </a>
          </div>
        );
      },
    },

    {
      headerName: "Date",
      field: "enquiry_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
   
    },
    {
      headerName: "Name",
      field: "student_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Father Name",
      field: "father_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Phone",
      field: "phone",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Previous Institute",
      field: "previous_institute",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const columnDDefs = [
    {
      headerName: "Enquiry Date",
      field: "enquiry_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Name",
      field: "student_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Father Name",
      field: "father_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Phone",
      field: "phone",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Previous Institute",
      field: "previous_institute",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Deleted Date",
      field: "updated_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return moment(params.value).format("DD-MM-YYYY");
      },
    },
  ];
  const location = useLocation();
  const [urllink, setUrllink] = useState("");
  useEffect(() => {
   
   

    const path = location.pathname.split("/")[2];
    setUrllink(path);

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setACList(arr);
        }
      }
    });
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
               
              }
            }
           
          }
        }
      });
    }else{
      setAcaID("");
    }

    
    if (localStorage.getItem("ADate") !== '') {
      setFDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
      setTDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
      listall(
        "",
        moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"),
        moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"),
        path
      );
    } else {
      setFDate(moment(new Date()).format("YYYY-MM-DD"));
      setTDate(moment(new Date()).format("YYYY-MM-DD"));
      listall(
        "",
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
        path
      );
    }
    
  }, [location.pathname]);

  function listall(aid, fdte, tdte,ltype) {
    setFDate(fdte);
    setTDate(tdte);
    setFilterProduct([]);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    temp.append("from_date", fdte);
    temp.append("to_date", tdte);
    if (ltype === "deleteenquiry") {
      temp.append("status", 0);
    } else {
      temp.append("status", 1);
    }
    listenquiry(temp).then((res) => {
      if (res.status === true) {
        // setFilterProduct(res.data);
        if(res.data.length>0){
          const cdata=res.data.map((item) => {
            return{
              ...item,
              enquiry_date: moment(item.enquiry_date).format("DD-MM-YYYY"),
            }
          });
          setFilterProduct(cdata);
        }
      }
    });
  }

  function deleteenq(did) {
    Swal.fire({
      text: "Are you sure want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteenquiry(did).then((response) => {
          if (response.status === true) {
            toast.success(response.message);
            navigate("/enquiry/deleteenquiry");
          }
        });
      }
    });
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e, fdate, tdate,urllink);
    } else {
      setAcaID("");
      listall("", fdate, tdate,urllink);
    }
  }

  return (
    <div>
      <div className="page-header">
        {urllink === "deleteenquiry" && (
          <h2 className="main-content-title tx-24 mg-b-5">Delete Enquiry</h2>
        )}
        {urllink === "allenquiry" && (
          <h2 className="main-content-title tx-24 mg-b-5">All Enquiry</h2>
        )}
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Admission Enquiry</a>
          </li>
          {urllink === "deleteenquiry" && (
            <li className="breadcrumb-item active" aria-current="page">
              Delete Enquiry
            </li>
          )}
          {urllink === "allenquiry" && (
            <li className="breadcrumb-item active" aria-current="page">
              All Enquiry
            </li>
          )}
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <div className="row">
                {localStorage.getItem("Role") === "1" && (
                  <div className="col-lg-4">
                    <label className="form-label">
                      Select Academy <span className="text-danger"> *</span>
                    </label>
                    <Select
                      className="default-select"
                      placeholder="Select Academy"
                      value={acaid}
                      options={aclist}
                      onChange={handleAcademy}
                      isSearchable={true}
                      isClearable
                      hidden
                    />
                  </div>
                )}

                <div className="col-lg-4">
                  <label className="form-label">From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    onChange={(e) => listall(acaid, e.target.value, tdate,urllink)}
                    value={fdate}
                  />
                </div>
                <div className="col-lg-4">
                  <label className="form-label">To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    onChange={(e) => listall(acaid, fdate, e.target.value,urllink)}
                    value={tdate}
                  />
                </div>
              </div>
              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={
                    urllink === "deleteenquiry" ? columnDDefs : columnDefs
                  }
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
